var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-list-group',_vm._l((_vm.items),function(item){return _c('nav-item',{key:item.id,attrs:{"item":item,"selected":_vm.selected}})}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }